import http from '@/plugins/http-common'
import {ResponseData} from './types'

class StatisticService {
    general = (): Promise<ResponseData> => http.get('/statistic/general', {})
}

export default new StatisticService()